import React from 'react';
import { FormattedMessage } from 'react-intl';
import ButtonTryAgain from '../components/buttons/ButtonTryAgain';
import Icon, { IconType } from '../components/icons/Icon';

type Props = {
  errorMessage: string | undefined;
  errorHeader?: string;
  displayTryAgain?: boolean;
  iconType?: IconType;
};
const ErrorView = ({
  errorMessage,
  errorHeader = 'errorView.title',
  displayTryAgain = true,
  iconType = 'WARNING',
}: Props) => {
  return (
    <main>
      <div className="column column-2">
        <article className="search-form">
          <header className="error-header">
            <span>
              <h1>
                <FormattedMessage id={errorHeader} />
              </h1>
            </span>
            <span>{iconType && <Icon type={iconType} />}</span>
          </header>
          <div className="error-container">
            <div>
              <FormattedMessage id={errorMessage} />
            </div>
          </div>
          {displayTryAgain ? <ButtonTryAgain className={"tryAgainScenario"}/> : null}
        </article>
      </div>
    </main>
  );
};

export default ErrorView;
